import { useEffect, useState, useMemo } from "react";
import "../../assets/css/admin_users_page.css";
import Header from "./includes_admin/Header";
import { API } from "../../http-common";
import { AdminAddButton } from "./Admin/AdminAddButton";
import { AdminCreateUserModal } from "./Admin/AdminCreateUserModal";
import { ModalConfirm } from "./Modal/ModalConfirm";
import { MoveBusinessModal } from "./Modal/ModalMoveBusiness";
import { Button, Alert } from "react-bootstrap";
import { getRoleLabel, getBusinessName, ROLE } from "../../helpers/constants";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export const AdminUsersPage = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [errorApi, setErrorApi] = useState("Cargando usuarios...");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [showDeleted, setShowDeleted] = useState(false);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [movingUser, setMovingUser] = useState(null);
  const [currentBusinessId, setCurrentBusinessId] = useState(null);
  const [modal, setModal] = useState({ isOpen: false, message: "", onConfirm: null });

  const toggleModal = () => setShowModal((prev) => !prev);
  
  const goBack = () => {
    history.push("/admin")
  }

  const users = useMemo(() => {
  const text = searchText.trim().toLowerCase();
  if (!text) return allUsers;

  return allUsers.filter((user) => {
    return (
      (user.username || "").toLowerCase().includes(text) ||
      (user.email || "").toLowerCase().includes(text)
    );
  });
  }, [allUsers, searchText]);

  const fetchUsers = async (deleted = showDeleted) => {
    try {
      setLoading(true);
      setErrorApi("Cargando usuarios...");
      const url = deleted ? "/user/deleted" : "/user/list";

      const response = await API.get(url);
      const data = response.data?.data || [];

      if (data.length > 0) {
        setAllUsers(data);
        setErrorApi("");
      } else {
        setAllUsers([]);
        setErrorApi(deleted ? "No se encontraron usuarios borrados." : "No se encontraron usuarios.");
      }
    } catch (error) {
      console.error("Error obteniendo usuarios:", error);
      setAllUsers([]);
      setErrorApi("Error al cargar usuarios.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    fetchUsers(showDeleted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDeleted]);

  const handleSearchChange = (e) => {
  setSearchText(e.target.value);
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setShowModal(true);
  };

  useEffect(() => {
    const fetchWhoAmI = async () => {
      try {
        const resp = await API.get("user/whoami");
        setCurrentBusinessId(resp?.data?.user?.home_business_id ?? null);
      } catch (error) {
        console.error("Error obteniendo whoami:", error);
      }
    };
    fetchWhoAmI();
  }, []);

  const handleDeleteUser = async (user) => {
    setModal({
      isOpen: true,
      message: `¿Seguro que querés dar de baja al usuario "${user.username}" (${user.email})?`,
      onConfirm: async () => {
        try {
          await API.delete(`/user/${user.id}`);
          await fetchUsers();
        } catch (error) {
          console.error("Error al eliminar usuario:", error);
          const msg =
            error.response?.data?.errors?.[0]?.msg || "Error al eliminar usuario.";
            setModal({ isOpen: true, message: msg, onConfirm: null });
        }
      },
    });
  };

    const handleRestoreUser = async (user) => {
    setModal({
      isOpen: true,
      message: `¿Seguro que querés restaurar al usuario "${user.username}" (${user.email})?`,
      onConfirm: async () => {
        try {
          await API.patch(`/user/${user.id}/restore`);
          await fetchUsers(true);
        } catch (error) {
          console.error("Error al restaurar usuario:", error);
          const msg =
            error.response?.data?.errors?.[0]?.msg || "Error al restaurar usuario.";
          setModal({ isOpen: true, message: msg, onConfirm: null });
        }
      },
    });
  };

  const handleOpenCreateModal = () => {
    setEditingUser(null);
    setShowModal(true);
  };

  const handleMoveUser = (user) => {
  setMovingUser(user);
  setShowMoveModal(true);
};

  return (
  <div className="container-fluid" id="applicant_container_fluid">
    <div className="row mb-4">
      <Header hideBusinessBadge />
    </div>

  <div className="admin_users_page">
    <div className="users_banner">
      <div className="users_header">
        <span className="users_title">Gestión de usuarios</span>
          {currentBusinessId != null && (
            <Alert
              variant="warning"
              className="users_business_alert"
              style={{ padding: "10px 14px" }}
            >
              Estás viendo usuarios de la Unidad de Negocio <b>{getBusinessName(currentBusinessId)}</b>
            </Alert>
          )}
            <Button
              size="md"
              onClick={goBack}
              className="users_back_btn btn-warning"
            >
              <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: 16, color: 'black' }} className="me-3" />
              Volver al inicio
            </Button>
      </div>
      <div className="users_controls">
        <input
          type="text"
          placeholder="Buscar usuario..."
          value={searchText}
          onChange={handleSearchChange}
          className="users_search"
        />

        <AdminAddButton onClick={handleOpenCreateModal} />

        <label className="users_deleted_toggle">
          <input
            type="checkbox"
            checked={showDeleted}
            onChange={(e) => setShowDeleted(e.target.checked)}
          />
          Listar usuarios borrados
        </label>
      </div>
    </div>
      <div className="admin_users_container">
        <div className="table-wrapper">
        <div className="table-responsive">

          {loading && <p>Cargando...</p>}
          {!loading && users.length === 0 && (
            <p>
              {searchText.trim()
                ? `No se encontraron usuarios para "${searchText}".`
                : errorApi}
            </p>
          )}
          {!loading && users.length > 0 && (
            <table className="table">
              <thead>
                <tr>
                  <th>Nombre de usuario</th>
                  <th>Email</th>
                  <th>Rol</th>
                  <th style={{ textAlign: "right" }}>Acciones</th>
                </tr>
              </thead>

              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.username}</td>
                    <td>{user.email}</td>
                    <td>{getRoleLabel(user.role_id)}</td>

                    <td style={{ textAlign: "right" }}>
                    {!showDeleted ? (
                      <>
                        <Button
                          variant="primary"
                          style={{ marginRight: 12 }}
                          onClick={() => handleEditUser(user)}
                        >
                          Editar
                        </Button>

                        <Button
                          variant="danger"
                          onClick={() => handleDeleteUser(user)}
                        >
                          Borrar
                        </Button>
                        <span
                          title={
                            user.role_id === ROLE.COMPLIANCE
                              ? "Los usuarios de Compliance no pueden moverse de unidad de negocio."
                              : undefined
                          }
                        >
                          <Button
                            variant="dark"
                            style={{
                              marginLeft: 12,
                              pointerEvents:
                                user.role_id === ROLE.COMPLIANCE ? "none" : "auto",
                            }}
                            onClick={() => handleMoveUser(user)}
                            disabled={user.role_id === ROLE.COMPLIANCE}
                          >
                            Mover
                          </Button>
                        </span>
                      </>
                      ) : (
                      <Button
                        variant="success"
                        onClick={() => handleRestoreUser(user)}
                      >
                        Restaurar
                      </Button>
                    )}
                  </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
            </div>
          </div>
        </div>
      </div>
      <AdminCreateUserModal
        isOpen={showModal}
        toggle={toggleModal}
        onUserCreated={fetchUsers}
        usersForRelation={allUsers}
        editingUser={editingUser}
      />
      <MoveBusinessModal
        isOpen={showMoveModal && !!movingUser}
        toggle={() => {
          setShowMoveModal(false);
          setMovingUser(null);
        }}
        user={movingUser}
        onMoved={() => fetchUsers(showDeleted)}
      />
      <ModalConfirm
        isOpen={modal.isOpen}
        toggle={() => setModal({ isOpen: false, message: "", onConfirm: null })}
        message={modal.message}
        onConfirm={modal.onConfirm}
      />
    </div>
  );
};

